<div *ngIf="team" class="planwrapper">

    <section class="program-section">
        <div class="section">
            <div>
                <span>Automated Bonuses</span>
            </div>
        </div>
    <table class="plans">
        <tr class="row" *ngFor="let program of programSettings">
            <td class="toggle"><mat-slide-toggle [checked]="program.enabled" (change)="toggleProgram($event, program)"></mat-slide-toggle></td>
            <td class="amount">{{program.amount | currency}}</td>
            <td class="programname">{{program.name}}</td>
            <td class="description">{{program.description}}</td>
            <td class="program-action"><button mat-raised-button color="accent" class="editbutton" [disabled]="!program.enabled" (click)="editProgram(program)">Edit</button></td>
        </tr>
    </table>
    </section>

    <section class="program-section">
    <div class="section">
        <div>
            <span>Automated Bonus History</span>
        </div>
    </div>
    <span *ngIf="historyItems.length === 0" class="norows">No automatic bonuses have been paid</span>
    <table class="history" *ngIf="historyItems.length > 0">
        <tr class="historyheader">
            <td class="firstheader">Sent To</td><td>Type</td><td>Amount</td><td [class.lastheader]="!canManageRewardClawbacks">Date Sent</td><td class="lastheader" *ngIf="canManageRewardClawbacks"></td>
        </tr>
        <tr *ngFor="let historyItem of historyItems">
            <td>{{historyItem.firstName}} {{historyItem.lastName}}</td>
            <td>
                <span>{{historyItem.type}}</span>
                <span *ngIf="historyItem.clawedBackAt" class="clawed-back-label">Clawed back</span>
            </td>
            <td>{{historyItem.amount | currency}}</td>
            <td [class.lastcol]="!canManageRewardClawbacks">{{historyItem.createdAt | date}}</td>
            <td class="lastcol" *ngIf="canManageRewardClawbacks">
                <button
                    mat-icon-button
                    [matMenuTriggerFor]="automatedBonusMenu"
                    [matMenuTriggerData]="{historyItem: historyItem}"
                    [disabled]="!canClawbackProgramLog(historyItem) || clawbackInProgressId === historyItem.id"
                    aria-label="Automated bonus actions">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </td>
        </tr>
    </table>
    <mat-menu #automatedBonusMenu="matMenu">
        <ng-template matMenuContent let-historyItem="historyItem">
            <button mat-menu-item (click)="clawbackProgramLog(historyItem)">
                <span>Clawback</span>
            </button>
        </ng-template>
    </mat-menu>
    </section>

    <section class="program-section">
    <div class="section">
        <div class="sectionitems">
            <div>
                <span>Scheduled Rewards</span>
            </div>
            <button mat-raised-button color="accent" class="editbutton" (click)="removeAllRewards()">Remove All</button>
        </div>
    </div>
    <span *ngIf="scheduledItems.length === 0" class="norows">There are no pending scheduled rewards</span>
    <table class="history" *ngIf="scheduledItems.length > 0">
        <tr class="historyheader">
            <td class="firstheader">Send on</td><td>Amount</td><td>Message</td><td class="lastheader">Recipient</td><td></td>
        </tr>
        <tr *ngFor="let scheduledItem of scheduledItems">
            <td>{{scheduledItem.date | date }}</td>
            <td>{{scheduledItem.amount | currency}}</td>
            <td *ngIf="this.isAfterCurrentDate(scheduledItem.date)">{{scheduledItem.message}}</td>
            <td *ngIf="!this.isAfterCurrentDate(scheduledItem.date)" class="failedpayment">Payment failed!</td>
            <td>{{scheduledItem.email}}</td>
            <td class="lastcol"><button mat-raised-button color="accent" class="editbutton" (click)="removeItem(scheduledItem)">Remove</button></td>
        </tr>
    </table>
    </section>

    <section class="program-section">
    <div class="section">
        <div class="sectionitems">
            <div>
                <span>Rewards History</span>
            </div>
        </div>
    </div>
    <span *ngIf="itemsSent.length === 0" class="norows">There are no sent rewards</span>
    <table class="history" *ngIf="itemsSent.length > 0">
        <tr class="historyheader">
            <td class="firstheader">Sent on</td><td>Amount</td><td>Message</td><td class="lastheader">Recipient</td><td></td>
        </tr>
        <tr *ngFor="let reward of itemsSent">
            <td>{{reward.dateSent | date}}</td>
            <td>{{reward.amount | currency}}</td>
            <td>{{reward.message}}</td>
            <td>{{reward.email}}</td>
            <td class="lastcol"><button mat-raised-button [ngStyle]="{opacity: 0}" [disabled]="true">Remove</button></td>
        </tr>
    </table>
    </section>

    <section class="program-section">
    <div class="section">
        <div class="sectionitems">
            <div>
                <span>One Time Rewards History</span>
            </div>
        </div>
    </div>
    <span *ngIf="oneTimeRewards?.length === 0" class="norows">There are no sent One Time Rewards</span>
    <table class="history" *ngIf="oneTimeRewards && oneTimeRewards.length > 0">
        <tr class="historyheader">
            <td class="firstheader">Sent on</td>
            <td>Amount</td>
            <td>Message</td>
            <td class="lastheader">Recipient</td>
            <td></td>
        </tr>
        <tr *ngFor="let reward of oneTimeRewards">
            <td>{{ reward?.transactionDate ? (reward.transactionDate | date) : '---' }}</td>
            <td>{{ reward?.amount ?? '---' | currency}}</td>
            <td>{{ reward?.description ?? '---' }}</td>
            <td>{{ reward?.recipient ?? '---' }}</td>
            <td class="lastcol">
                <button mat-raised-button [ngStyle]="{opacity: 0}" [disabled]="true">Remove</button>
            </td>
        </tr>
    </table>
    </section>
</div>
